"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const selectors_1 = require("~/store/selectors");
const types_1 = require("~/store/types");
const controls_1 = require("~/components/common/controls");
const UI_1 = require("~/components/UI");
const redux_1 = require("redux");
const actions_1 = require("~/store/actions");
const assets_1 = require("~/assets");
const AddressEditor_module_scss_1 = __importDefault(require("./AddressEditor.module.scss"));
function AddressEditor({ address, onValidStateChange, onAddressChange, onAddressDelete }) {
    var _a, _b, _c;
    const { dispatchFetchData } = (0, redux_1.bindActionCreators)({ dispatchFetchData: actions_1.fetchData }, (0, react_redux_1.useDispatch)());
    (0, react_1.useEffect)(() => {
        dispatchFetchData();
    }, []);
    const { t } = (0, react_i18next_1.useTranslation)(['quote-widget', 'customer']);
    const [addressLine, setAddressLine] = (0, react_1.useState)(address.addressLine);
    const [addressLine2, setAddressLine2] = (0, react_1.useState)((_a = address.addressLine2) !== null && _a !== void 0 ? _a : '');
    const [city, setCity] = (0, react_1.useState)(address.city);
    const [state, setState] = (0, react_1.useState)(address.state);
    const [zip, setZip] = (0, react_1.useState)(address.zip);
    const [currentCountryId, setCurrentCountryId] = (0, react_1.useState)(address.country_id);
    const countries = (0, react_redux_1.useSelector)(selectors_1.selectCountries);
    const states = (0, react_redux_1.useSelector)(selectors_1.selectStates);
    const isDataLoading = (0, react_redux_1.useSelector)(selectors_1.selectIsDataLoading);
    const [statesForCountry, setStatesForCountry] = (0, react_1.useState)([]);
    const currentState = statesForCountry.length > 0 && state !== ''
        ? (_b = statesForCountry.find((stateForCountry) => stateForCountry.name === state)) !== null && _b !== void 0 ? _b : null
        : null;
    const [isValid, setIsValid] = (0, react_1.useState)(false);
    const countriesWithStates = [...new Set(states.map((st) => st.countryId))];
    (0, react_1.useEffect)(() => {
        const currentCountryStates = states.filter((currentCountryState) => currentCountryState.countryId === currentCountryId);
        if (countriesWithStates.includes(currentCountryId) && !currentCountryStates.length) {
            setState('');
        }
        setStatesForCountry(currentCountryStates);
    }, [currentCountryId, states]);
    (0, react_1.useEffect)(() => {
        const isCurrentStateInvalid = addressLine.trim() === '' ||
            city.trim() === '' ||
            state.trim() === '' ||
            zip.trim() === '' ||
            zip.trim().length < 3 ||
            !currentCountryId;
        if (isValid === isCurrentStateInvalid) {
            onValidStateChange(address.id, !isCurrentStateInvalid);
            setIsValid(!isCurrentStateInvalid);
        }
    }, [addressLine, city, state, zip, currentCountryId]);
    (0, react_1.useEffect)(() => {
        onAddressChange({
            addressLine: addressLine.trim(),
            addressLine2: addressLine2.trim(),
            city: city.trim(),
            state,
            zip: zip.trim(),
            country_id: currentCountryId,
            id: address.id,
        });
    }, [addressLine, addressLine2, city, state, zip, currentCountryId]);
    const onDelete = () => {
        onAddressDelete(address.id);
    };
    return isDataLoading === types_1.LOADING_STATE.COMPLETE ? (react_1.default.createElement("div", { className: AddressEditor_module_scss_1.default.content },
        react_1.default.createElement("form", null,
            react_1.default.createElement("div", { className: AddressEditor_module_scss_1.default.row },
                react_1.default.createElement("div", { className: AddressEditor_module_scss_1.default.element_growing },
                    react_1.default.createElement(UI_1.Input, { placeholder: t('placeholder.shipping-address.street'), value: addressLine, onChange: setAddressLine, onInput: setAddressLine, maxLength: 255, customErrors: {
                            required: t('error.street-adress.required', { ns: 'customer' }),
                        }, required: true })),
                react_1.default.createElement("div", { className: AddressEditor_module_scss_1.default['element_centered-content'] },
                    react_1.default.createElement("img", { onClick: onDelete, onKeyDown: (e) => e.key === 'Enter' && onDelete(), src: assets_1.svgBasicTrashIcon, alt: "delete", className: AddressEditor_module_scss_1.default.image, tabIndex: 0, role: "button" }))),
            react_1.default.createElement("div", { className: AddressEditor_module_scss_1.default.row },
                react_1.default.createElement("div", { className: AddressEditor_module_scss_1.default.element_growing },
                    react_1.default.createElement(UI_1.Input, { placeholder: t('placeholder.shipping-address.additional-line'), value: addressLine2, onChange: setAddressLine2, onInput: setAddressLine2, maxLength: 255 }))),
            react_1.default.createElement("div", { className: AddressEditor_module_scss_1.default.row },
                react_1.default.createElement("div", { className: AddressEditor_module_scss_1.default.element_growing },
                    react_1.default.createElement(UI_1.Input, { placeholder: t('placeholder.shipping-address.city'), value: city, onChange: setCity, onInput: setCity, maxLength: 60, customErrors: {
                            required: t('error.city.required', { ns: 'customer' }),
                        }, required: true })),
                react_1.default.createElement("div", { className: AddressEditor_module_scss_1.default.element_growing }, statesForCountry.length === 0 ? (react_1.default.createElement(UI_1.Input, { placeholder: t('placeholder.shipping-address.state'), value: state, onChange: setState, onInput: setState, maxLength: 60, required: true })) : (react_1.default.createElement(controls_1.FormDropdown, { inputKey: "state", state: { error: '', value: currentState ? { key: currentState.id, value: currentState.name } : null }, onInput: (key, id) => {
                        var _a, _b;
                        setState((_b = (_a = states.find((st) => st.id === id)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '');
                    }, onError: () => { }, options: statesForCountry
                        ? statesForCountry.map((stateForCountry) => ({
                            key: stateForCountry.id,
                            value: stateForCountry.name,
                        }))
                        : [], placeholder: t('placeholder.shipping-address.state'), required: true })))),
            react_1.default.createElement("div", { className: AddressEditor_module_scss_1.default.row },
                react_1.default.createElement("div", { className: AddressEditor_module_scss_1.default.element_growing },
                    react_1.default.createElement(UI_1.Input, { placeholder: t('placeholder.shipping-address.zip'), value: zip, onChange: setZip, onInput: setZip, maxLength: 9, minLength: 3, required: true, customErrors: {
                            'min-value': t('shipping-address.zip-validation'),
                            'required': t('error.zip.required', { ns: 'customer' }),
                        } })),
                react_1.default.createElement("div", { className: AddressEditor_module_scss_1.default.element_growing },
                    react_1.default.createElement(controls_1.FormDropdown, { inputKey: "country", state: {
                            value: currentCountryId
                                ? {
                                    value: (_c = countries.find((country) => country.id === currentCountryId)) === null || _c === void 0 ? void 0 : _c.name,
                                    key: currentCountryId,
                                }
                                : null,
                            error: '',
                        }, options: countries
                            ? [...countries]
                                .sort((a, b) => a.order - b.order)
                                .map((country) => ({
                                key: country.id,
                                value: country.name,
                            }))
                            : [], onInput: (key, id) => {
                            setCurrentCountryId(Number(id));
                        }, onError: () => { }, placeholder: t('placeholder.shipping-address.country') })))))) : null;
}
exports.default = AddressEditor;
